const alertPalette = (tokens) => {
    return {
        padding: tokens.alertPadding,
        spaceBetween: tokens.alertSpaceBetween,
        boxShadow: {
            inline: tokens.alertBoxShadowInline,
            floating: tokens.alertBoxShadowFloating
        },
        border: {
            width: tokens.alertBorderWidth,
            radius: tokens.alertRadius
        },
        neutral: {
            text: tokens.alertColorTextNeutral,
            error: {
                text: tokens.alertColorTextErrorNeutral,
                background: tokens.alertColorBgErrorNeutral,
                border: tokens.alertColorBorderErrorNeutral
            },
            warning: {
                background: tokens.alertColorBgWarningNeutral,
                border: tokens.alertColorBorderWarningNeutral
            },
            info: {
                background: tokens.alertColorBgInfoNeutral,
                border: tokens.alertColorBorderInfoNeutral
            },
            success: {
                background: tokens.alertColorBgSuccessNeutral,
                border: tokens.alertColorBorderSuccessNeutral
            }
        },
        emphasis: {
            text: tokens.aliasesColorTextStaticInverse,
            info: {
                background: tokens.alertColorBgInfoEmphasis,
                border: tokens.alertColorBorderInfoEmphasis
            }
        },
        font: {
            family: tokens.alertFontFamily,
            size: tokens.aliasesFontSizeDefault,
            weight: tokens.aliasesFontWeightDefault,
            lineHeight: tokens.aliasesLineHeightDefault,
            letterSpacing: tokens.aliasesLetterSpacingDefault,
            title: {
                size: tokens.alertTitleFontSize,
                weight: tokens.alertTitleFontWeight,
                lineHeight: tokens.alertTitleLineHeight
            }
        }
    };
};
export default alertPalette;
//# sourceMappingURL=alert.js.map